/*************** dragEvents.js ***************** */
//imported into criteria.js
//allows selected criteria to be rearranged via drag/drop


const ranked = document.querySelector('#ss-ranked');
let draggable;

const dragStart = e => {
  draggable = e.target;
  draggable.classList.add('dragging');
}

const dragEnd = e => {
  e.target.classList.remove('dragging');
}

const dragOver = e => {
  e.preventDefault();
  let afterElement = getDragAfterElement(ranked, e.clientY);
  if (afterElement == null) {
    ranked.appendChild(draggable);
  } else {
    ranked.insertBefore(draggable, afterElement);
  }
}

const getDragAfterElement = (container, y) => {
  /* let items = Array.prototype.slice.call(container.querySelectorAll('li:not(.dragging')); // doesn't work on ios with DragDropTouch.js */
  let items = Array.prototype.slice.call(container.querySelectorAll('li'));

  return items.reduce((closest, child) => {
    let box = child.getBoundingClientRect();
    let offset = y - box.top - box.height * .5;
    if (offset < 0 && offset > closest.offset) {
      return { offset: offset, element: child };
    } else {
      return closest;
    }
  }, { offset: Number.NEGATIVE_INFINITY}).element;
}
ranked.addEventListener('dragover', dragOver);

export {dragStart, dragEnd, dragOver, getDragAfterElement}